import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

const toast = useToast();

 export const customerUtils = {
  /**
   * Search customers by keyword
   * @param {string} search - Search keyword
   * @returns {Promise<Array>} - List of customers
   */
  async onSearch(search) {
    if (!search || search.length < 2) return [];
    
    try {
      const response = await axios.get('/customers/dropdown', { 
        params: { search_keyword: search } 
      });
      return response.data.data;
    } catch (error) {
      toast.error(error.message);
      return [];
    }
  },

  /**
   * Get customer by ID
   * @param {number} id - Customer ID
   * @returns {Promise<Object|null>} - Customer object or null
   */
  async getCustomerById(id) {
    try {
      const response = await axios.get(`/customers/${id}`);
      return response.data.data;
    } catch (error) {
      toast.error("Customer not found");
      return null;
    }
  }
 };